import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  FIELDS,
  LOADING,
  MODE,
  TOAST_MESSAGES,
} from "../../../constants/SiteConstants";
import ServiceForm from "./ServiceForm";

const API_URL = process.env.REACT_APP_API_URL;

const fields = [
  {
    label: FIELDS.TITLE,
    name: "title",
    placeholder: "Enter Title",
    required: true,
  },
  {
    label: FIELDS.ICON,
    name: "icon",
    placeholder: "Select icon",
    required: true,
  },
];

const EditService = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialData, setInitialData] = useState(null);

  useEffect(() => {
    if (id) {
      loadServiceData();
    }
  }, [id]);

  const loadServiceData = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/services/getServiceById/${id}`
      );
      setInitialData(response.data);
    } catch (error) {
      toast.error(TOAST_MESSAGES.ERROR_FETCH);
    }
  };

  const handleSubmit = async (formData) => {
    try {
      await axios.put(`${API_URL}/services/updateService/${id}`, formData);
      toast.success(TOAST_MESSAGES.DATA_UPDATED);
      navigate("/services");
    } catch (error) {
      toast.error(TOAST_MESSAGES.ERROR_UPDATE);
    }
  };

  return (
    <div className="form-wrapper">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Update Service
        </h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/services")}
        >
          &times;
        </button>
      </div>
      {initialData ? (
        <ServiceForm
          mode={MODE.UPDATE}
          onSubmit={handleSubmit}
          fields={fields}
          initialData={initialData}
          selectedType="dropdown"
          onAddMulti={true}
          passOptionsinString={true}
          showOptionsinEditMode={true}
        />
      ) : (
        <p>{LOADING}</p>
      )}
    </div>
  );
};

export default EditService;
